import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { IconChevronsRight, IconSquareRoundedXFilled } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { useLocaleFormatter } from "@ct-react/locale";
import { globalTranslations } from "../../../i18n/sharable-defs";
import { useInterhomeContext } from "./interhome-outlet";
import { Button } from "../../../components/common/minimals";
import Modal, { InnerModal } from "../../../components/common/modal";

const transDefs = defineMessages({
  unknown: { id: "interhome-error-unknown", defaultMessage: "Erreur !" },
  unknownDetail: { id: "interhome-error-unknown-detail", defaultMessage: "Une erreur inconnue est survenue. Veuillez ressayer ultérieurement." },
  unavailable: { id: "interhome-error-unavailable", defaultMessage: "Période indisponible !" },
  unavailableDetail: { id: "interhome-error-unavailable-detail", defaultMessage: "La période {period} n'est plus disponible pour ce bien." }
});

export type InterhomeQueryErrorType = "unavailable" | "unknown";

type Props = {
  type: InterhomeQueryErrorType;
  actionLabel?: string;
  withIcon?: boolean;
  onAction: () => void;
}

export const InterhomeErrorDisplay = ({ type, actionLabel, withIcon = false, onAction }: Props) => {

  const intl = useIntl();
  const { print } = useLocaleFormatter();
  const [ { item: { period } } ] = useInterhomeContext();
  const wrapperClasses = classNames("error", type);

  return (
    <div className={wrapperClasses}>

      <div className="message">
        <IconSquareRoundedXFilled />
        <span>{intl.formatMessage(transDefs[type])}</span>
      </div>

      {type === "unavailable" &&
        <p>{intl.formatMessage(transDefs.unavailableDetail, { period: print.period(period, true, true) })}</p>
      }
      {type === "unknown" &&
        <p>{intl.formatMessage(transDefs.unknownDetail)}</p>
      }

      <Button type="button"
              className="link bolder small inline-icon right-align"
              onClick={onAction}>
        {!!actionLabel ? actionLabel : intl.formatMessage(globalTranslations.back)}
        {withIcon && <IconChevronsRight />}
      </Button>

    </div>);

}

export const InterhomeErrorModal = ({ type, actionLabel, withIcon, onAction }: Props) => {

  const [ open, setOpen ] = useState<boolean>(true);

  const onClose = () => {
    setOpen(false);
    onAction();
  }

  return (
    <Modal size="sm"
           closableCross={false}
           open={open}>
      <InnerModal.Content className="interhome">
        <InterhomeErrorDisplay type={type}
                               actionLabel={actionLabel}
                               withIcon={withIcon}
                               onAction={onClose} />
      </InnerModal.Content>
    </Modal>);

}
